export default "__VITE_ASSET__CoODp1g8__"